import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 20px',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '10px',
    marginBottom: '40px'
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '30px',
    flexWrap: 'wrap',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  imageContainer: {
    flex: '0 0 235px',
    '@media (max-width: 768px)': {
      marginBottom: '20px'
    }
  },
  image: {
    width: '235px',
    height: '235px',
    borderRadius: '50%',
    objectFit: 'cover'
  },
  info: {
    flex: 1,
    minWidth: '280px'
  },
  title: {
    color: props => props.customStyles?.textColor || '#ffffff',
    fontSize: '36px',
    fontFamily: '"Roboto Slab", serif',
    fontWeight: 700,
    marginBottom: '20px',
    lineHeight: 1.4
  },
  bio: {
    color: props => props.customStyles?.textColor || '#ffffff',
    fontSize: '18px',
    lineHeight: 1.6,
    marginBottom: '30px',
    whiteSpace: 'pre-line'
  },
  achievements: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  achievement: {
    color: props => props.customStyles?.textColor || '#ffffff',
    fontSize: '16px',
    lineHeight: 1.6,
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '&:before': {
      content: '"✓"',
      color: '#4CAF50',
      fontWeight: 'bold'
    }
  }
}));

export const InstructorSection = ({ customContent, customStyles }) => {
  const classes = useStyles({ customStyles });
  
  // Use customContent if provided, otherwise use default values
  const {
    title = "🎓 About Your Instructor – Hector Castillo",
    image = "https://cdn.builder.io/api/v1/image/assets/e6ab85e93ad9451db00e45c8874777d7/cfa592a33f248292db391bf7844c9b177b210851",
    bio = "Hi, I'm Hector Castillo, and I've been teaching men how to successfully meet and connect with women for over a decade. Through years of experience and real-world testing, I've developed proven methods that work in any location - whether it's at the beach, in a mall, or on public transportation. My approach focuses on authentic connections and genuine confidence.",
    achievements = [
      "Over 10 years of coaching experience",
      "Helped thousands of students improve their dating lives",
      "Author of multiple successful dating guides",
      "Featured in major dating and lifestyle publications"
    ]
  } = customContent?.instructor || {};

  return (
    <section className={classes.section}>
      <div className={classes.content}>
        <div className={classes.imageContainer}>
          <img
            src={image}
            alt="Instructor Hector Castillo"
            className={classes.image}
          />
        </div>
        <div className={classes.info}>
          <Typography variant="h2" className={classes.title}>
            {title}
          </Typography>
          <Typography variant="body1" className={classes.bio}>
            {bio}
          </Typography>
          {achievements && achievements.length > 0 && (
            <ul className={classes.achievements}>
              {achievements.map((achievement, index) => (
                <li key={index} className={classes.achievement}>
                  {achievement}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}; 